import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { FeaturesModule } from '@flyfreely-portal-ui/features';
import { EquipmentService } from '@flyfreely-portal-ui/flyfreely';
import { FlyFreelyTableModule } from '@flyfreely-portal-ui/flyfreely-table';
import { MaintenanceModule } from '@flyfreely-portal-ui/maintenance';
import { ResourceUiModule } from '@flyfreely-portal-ui/resource-ui';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { ngfModule } from 'angular-file';
import { AttachmentsModule } from 'libs/attachments/src/lib/attachments.module';
import { AuthorityModule } from 'libs/authorities/src/lib/authorities.module';
import { BulkUploadsModule } from 'libs/bulk-uploads/src/lib/bulk-uploads.module';
import { CommonDialoguesModule } from 'libs/common-dialogues/src/lib/common-dialogues.module';
import { DocumentationModule } from 'libs/documentation/src/lib/documentation.module';
import { FlightHistoryModule } from 'libs/flight-history/src/lib/flight-history.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { WorkflowModule } from 'libs/workflows/src/lib/workflows.module';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ToastrModule } from 'ngx-toastr';
import { CreateEquipmentTypeDialogue } from './add/create-equipment-type-dialogue.component';
import { EquipmentAddDialogue } from './add/equipment-add.component';
import { EquipmentEdit } from './edit/equipment-edit.component';
import { EquipmentDialogue } from './equipment-dialogue.component';
import { EquipmentDialoguesService } from './equipment-dialogues.service';
import { NotesEditComponent } from './equipment-notes/notes-edit/notes-edit.component';
import { NotesViewComponent } from './equipment-notes/notes-view/notes-view.component';
import { EquipmentView } from './view/equipment-view.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        // ngx-bootstrap
        TooltipModule,
        ModalModule.forChild(),
        TabsModule,
        BsDropdownModule,
        BsDatepickerModule,
        ButtonsModule,
        // ngx-formly
        ReactiveFormsModule,
        FormlyModule,
        FormlyBootstrapModule,
        // ng-select
        NgSelectModule,
        ngfModule,
        ToastrModule,
        SharedUiModule,
        DocumentationModule,
        WorkflowModule,
        FlightHistoryModule,
        AttachmentsModule,
        LoadingIndicatorModule,
        AuthorityModule,
        MaintenanceModule,
        CommonDialoguesModule,
        ValidationModule,
        FlyFreelyTableModule,
        EnhancedHelpModule,
        AnalyticsModule,
        BulkUploadsModule,
        ResourceUiModule,
        FeaturesModule
    ],
    providers: [EquipmentService, EquipmentDialoguesService],
    bootstrap: [],
    declarations: [
        EquipmentDialogue,
        EquipmentEdit,
        EquipmentView,
        EquipmentAddDialogue,
        CreateEquipmentTypeDialogue,
        NotesEditComponent,
        NotesViewComponent
    ],
    exports: []
})
export class EquipmentModule {}
